import Axios from '../Axios';

const card = {
	create(data) {
		return Axios.post('/cards', data);
	},
	topUp(data) {
		return Axios.post('/recharges', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get('/cards?limit=' + limit + '&page=' + page + search);
	},
	readNoUsed(limit = 10, page = 1) {
		return Axios.get('/cards?user=null&limit=' + limit + '&page=' + page);
	},
	readOne(id) {
		return Axios.get('/cards/' + id);
	},
	update(id, data) {
		return Axios.put('/cards/' + id, data);
	},
	delete(id) {
		return Axios.delete('/cards/' + id);
	},
};

export default card;
